// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_SET_FAVORITE_TOPIC = "pridanie f\u00f3ra do ob\u013e\u00faben\u00fdch";
export const ACTION_TO_SUBSCRIBE_TOPIC = "odoberanie f\u00f3ra";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_TOPIC = "Naozaj chce\u0161 f\u00f3rum zmaza\u0165?";
export const EXPLAIN_TOPIC_DELETION = "Zadaj bli\u017e\u0161ie od\u00f4vodnenie: ";
export const FORUM_FEED_SUBSCRIBED = "Odober\u00e1m";
export const FORUM_TOPIC_SUBSCRIBED_TOAST_name_link = "Za\u010dala si odobera\u0165 %(name)s.";
export const FORUM_TOPIC_topic_IS_ADDED_TO_FAVORITES = "Pridala si f\u00f3rum %(topic)s k ob\u013e\u00faben\u00fdm.";
export const FORUM_TOPIC_topic_IS_REMOVED_FROM_FAVORITES = "Odstr\u00e1nila si f\u00f3rum %(topic)s z ob\u013e\u00faben\u00fdch.";
